import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.funding_requirements.action_applicant_call_self_serve_title',
        defaultMessage: 'You’re all set for now'
    },
    caption: {
        id: '_.funding_requirements.action_applicant_call_self_serve_caption',
        defaultMessage:
            'We’re wrapping up some final checks and will be in touch soon.'
    }
});
